import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bf2c9962"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "API URL", -1));
const _hoisted_2 = { class: "base_url_box" };
const _hoisted_3 = { class: "button_box" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "btn-txt" };
const _hoisted_6 = ["disabled", "onClick"];
const _hoisted_7 = { class: "btn-txt" };
const _hoisted_8 = { class: "button_box" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "button_box" };
const _hoisted_11 = ["onClick"];
import { reactive, inject } from 'vue';
import ApiAccessTokenForm from './ApiAccessTokenForm.vue';
import ApiAccessTokenList from './ApiAccessTokenList.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import VerifyOnetimePasscode from '@/components/organisms/modal/VerifyOnetimePasscode.vue';
import ApiAccessTokenResult from '@/components/organisms/modal/ApiAccessTokenResult.vue';
import { useMessage } from '@/const/messages';
import { useApiAccessToken } from '@/logics/api_access_token';
import { useApiRole } from '@/logics/api_role';
import { useOneTimePasscode } from '@/logics/one_time_passcode';
import { useClipboard } from '@vueuse/core';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const LIST_PAGE = 'list';
        const CREATE_PAGE = 'create';
        const EDIT_PAGE = 'edit';
        const userApiUrl = String(process.env.VUE_APP_USER_API_URL);
        const toast = inject('toast');
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const { getApiAccessTokens, postApiAccessToken, updateApiAccessToken, extendApiAccessToken, deleteApiAccessToken, deleteAllApiAccessToken, } = useApiAccessToken();
        const { getApiRoles } = useApiRole();
        const { checkVerified } = useOneTimePasscode();
        const { copy, copied, isSupported } = useClipboard({ legacy: true });
        const state = reactive({
            pageType: LIST_PAGE,
            apiAccessTokens: [],
            apiRoles: [],
            errors: {},
            isLoading: false,
            isShowOnetimePasscodeModal: false,
            callbackVerifiedOnetimePasscode: () => ({}),
            isShowApiAccessTokenResultModal: false,
        });
        const initialize = () => __awaiter(this, void 0, void 0, function* () {
            state.apiAccessTokens = yield getApiAccessTokens();
            state.apiRoles = yield getApiRoles();
        });
        const changePage = (pageType) => {
            state.errors = {};
            state.pageType = pageType;
        };
        const onVerifiedOnetimePasscode = () => __awaiter(this, void 0, void 0, function* () { return state.callbackVerifiedOnetimePasscode(); });
        const onCloseOnetimePasscodeModal = () => (state.isShowOnetimePasscodeModal = false);
        const onShowOnetimePasscodeModal = () => __awaiter(this, void 0, void 0, function* () {
            if (state.isLoading)
                return;
            state.isLoading = true;
            try {
                yield checkVerified();
                yield onVerifiedOnetimePasscode();
            }
            catch (err) {
                if (err.response.status == 404) {
                    state.isShowOnetimePasscodeModal = true;
                }
                else {
                    console.error(err);
                }
            }
            finally {
                state.isLoading = false;
            }
        });
        const onCloseApiAccessTokenResultModal = () => (state.isShowApiAccessTokenResultModal = false);
        const onClickCreate = () => __awaiter(this, void 0, void 0, function* () {
            state.callbackVerifiedOnetimePasscode = () => changePage(CREATE_PAGE);
            onShowOnetimePasscodeModal();
        });
        const onClickEdit = (id) => __awaiter(this, void 0, void 0, function* () {
            state.callbackVerifiedOnetimePasscode = () => {
                state.selectedApiAccessToken = state.apiAccessTokens.find((t) => t.id === id);
                changePage(EDIT_PAGE);
            };
            onShowOnetimePasscodeModal();
        });
        const onClickExtend = (id) => __awaiter(this, void 0, void 0, function* () {
            state.callbackVerifiedOnetimePasscode = () => __awaiter(this, void 0, void 0, function* () {
                yield extendApiAccessToken(id);
                state.apiAccessTokens = yield getApiAccessTokens();
                toast.success(format(MYPAGE_API_MANAGEMENT.SUCCESS_EXTEND_API));
            });
            onShowOnetimePasscodeModal();
        });
        const onClickDelete = ({ id, label }) => __awaiter(this, void 0, void 0, function* () {
            if (!confirm(format(MYPAGE_API_MANAGEMENT.CONFIRM_DELETE).replaceAll('{{label}}', label)))
                return;
            state.callbackVerifiedOnetimePasscode = () => __awaiter(this, void 0, void 0, function* () {
                yield deleteApiAccessToken(id);
                state.apiAccessTokens = yield getApiAccessTokens();
                toast.success(format(MYPAGE_API_MANAGEMENT.SUCCESS_DELETE_API));
            });
            onShowOnetimePasscodeModal();
        });
        const onClickDeleteAll = () => __awaiter(this, void 0, void 0, function* () {
            if (!confirm(format(MYPAGE_API_MANAGEMENT.CONFIRM_DELETE_ALL)))
                return;
            state.callbackVerifiedOnetimePasscode = () => __awaiter(this, void 0, void 0, function* () {
                deleteAllApiAccessToken();
                state.apiAccessTokens = [];
            });
            onShowOnetimePasscodeModal();
        });
        const onClickBack = () => __awaiter(this, void 0, void 0, function* () { return changePage(LIST_PAGE); });
        const onSubmit = (form) => __awaiter(this, void 0, void 0, function* () {
            if (state.isLoading)
                return;
            state.isLoading = true;
            try {
                state.errors = {};
                if (!!form.id) {
                    yield updateApiAccessToken(form.id, form.label, form.roles);
                }
                else {
                    state.resultApiAccessToken = yield postApiAccessToken(form.label, form.roles);
                    state.isShowApiAccessTokenResultModal = true;
                }
                state.apiAccessTokens = yield getApiAccessTokens();
                state.pageType = LIST_PAGE;
            }
            catch (err) {
                if (!!err.response && err.response.status === 400) {
                    state.errors = {
                        label: !!err.response.data.errors.label ? err.response.data.errors.label[0] : '',
                        roles: !!err.response.data.errors.roles ? err.response.data.errors.roles[0] : '',
                    };
                }
                throw err;
            }
            finally {
                state.isLoading = false;
            }
        });
        initialize();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).isShowOnetimePasscodeModal)
                    ? (_openBlock(), _createBlock(VerifyOnetimePasscode, {
                        key: 0,
                        onSubmitted: onVerifiedOnetimePasscode,
                        onClose: onCloseOnetimePasscodeModal
                    }))
                    : _createCommentVNode("", true),
                (_unref(state).isShowApiAccessTokenResultModal && !!_unref(state).resultApiAccessToken)
                    ? (_openBlock(), _createBlock(ApiAccessTokenResult, {
                        key: 1,
                        "api-access-token": _unref(state).resultApiAccessToken,
                        onClose: onCloseApiAccessTokenResultModal
                    }, null, 8, ["api-access-token"]))
                    : _createCommentVNode("", true),
                (_unref(state).pageType === LIST_PAGE)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_1,
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", null, _toDisplayString(_unref(userApiUrl)), 1),
                            (_unref(isSupported))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "#",
                                    class: "link",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(copy)(_unref(userApiUrl))), ["prevent"]))
                                }, _toDisplayString(_unref(copied) ? 'Copied!' : 'Copy'), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("button", {
                                class: "act-btn",
                                style: { "margin-right": "10px" },
                                onClick: _withModifiers(onClickCreate, ["prevent"])
                            }, [
                                _createVNode(MaterialIcon, {
                                    name: "edit",
                                    class: "icon",
                                    style: { "margin-right": "5px" }
                                }),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_CREATE_API)), 1)
                            ], 8, _hoisted_4),
                            _createElementVNode("button", {
                                class: "act-btn --delete",
                                disabled: _unref(state).apiAccessTokens.length == 0,
                                onClick: _withModifiers(onClickDeleteAll, ["prevent"])
                            }, [
                                _createVNode(MaterialIcon, {
                                    name: "delete",
                                    class: "icon",
                                    style: { "margin-right": "5px" }
                                }),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_DELETE_ALL_API)), 1)
                            ], 8, _hoisted_6)
                        ]),
                        _createVNode(ApiAccessTokenList, {
                            "api-access-tokens": _unref(state).apiAccessTokens,
                            onClickEdit: onClickEdit,
                            onClickExtend: onClickExtend,
                            onClickDelete: onClickDelete
                        }, null, 8, ["api-access-tokens"])
                    ], 64))
                    : (_unref(state).pageType === CREATE_PAGE)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("a", {
                                    href: "#",
                                    class: "link",
                                    onClick: _withModifiers(onClickBack, ["prevent"])
                                }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).LINK_BACK_TO_LIST)), 9, _hoisted_9)
                            ]),
                            _createVNode(ApiAccessTokenForm, {
                                "api-access-token-form": { label: '', roles: [] },
                                "api-roles": _unref(state).apiRoles,
                                errors: _unref(state).errors,
                                onSubmitted: onSubmit
                            }, null, 8, ["api-roles", "errors"])
                        ], 64))
                        : (_unref(state).pageType === EDIT_PAGE)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("a", {
                                        href: "#",
                                        class: "link",
                                        onClick: _withModifiers(onClickBack, ["prevent"])
                                    }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).LINK_BACK_TO_LIST)), 9, _hoisted_11)
                                ]),
                                (!!_unref(state).selectedApiAccessToken)
                                    ? (_openBlock(), _createBlock(ApiAccessTokenForm, {
                                        key: 0,
                                        "api-access-token-form": _unref(state).selectedApiAccessToken,
                                        "api-roles": _unref(state).apiRoles,
                                        errors: _unref(state).errors,
                                        onSubmitted: onSubmit
                                    }, null, 8, ["api-access-token-form", "api-roles", "errors"]))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true)
            ], 64));
        };
    }
});
